module.exports = __webpack_public_path__ + "img/5-3.a819dc7b.png";